<template>
  <div class="site-aside-container">
    <div class="avatar">
      <Avatar v-if="data.avatar" :src="avatar" />
    </div>
    <h1 class="title">{{data.siteTitle}}</h1>
    <Menu />
    <Contact />
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Avatar from "@/components/Avatar";
import Contact from "./Contact";
import Menu from "./Menu";
import {SERVER_URL} from '@/util/urlConfig'

export default {
  name: "SiteAside",
  components: {
    Avatar,
    Contact,
    Menu,
  },
  computed:{
    ...mapState('options',['data']),
    avatar(){
      return SERVER_URL + this.data.avatar
    }
  }
};
</script>

<style lang="less" scoped>
.site-aside-container {
  background-color: #000;
  padding: 50px 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  .avatar {
    text-align: center;
  }
  .title {
    color: #fff;
    margin: 20px 0;
    text-align: center;
  }
}
</style>
